import React, { useState } from 'react';

import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

import DashBoard from '../DashBoard/Home';
import SliderPages from '../PlaceHolder/SliderPages';
import { AdminAuthoritiesProvider } from '../context/ContextForAdminPages';
const LazyDrDashBoard = React.lazy(() => import('./YourRequests'));
const LazyDashBoardHomePage = React.lazy(() => import('../DashBoard/DashBoardMainPage'));
const LazyWorkCareDash = React.lazy(() => import('../DashBoard/WorkCare'));
const LazyAuthrizationGiving = React.lazy(() => import('./AutherizationGiving'));
const LazyDrRequest = React.lazy(() => import('./drRequests'));
const LazyDrAutherizationGiving = React.lazy(() => import('./DrAutherizationGiving'));
export default function DashBoardNavigation(props) {
    const [userRole,setUserRole] = useState('');
    return(
            <Router>
                <AdminAuthoritiesProvider role={setUserRole}>
                    <DashBoard>
                        <Routes>
                            <Route path={`/analysis`} element={
                                <React.Suspense fallback={<SliderPages/>}>
                                    <LazyDashBoardHomePage/>
                                </React.Suspense>
                            } 
                            />
                            <Route path={'/'} element={
                                <React.Suspense fallback={<SliderPages/>}>
                                    {/* <LazyHomeCareDash/> */}
                                    <LazyWorkCareDash context={'enquiry'}  request="DrhomeServiceRequests" header={'Dr. Home Requests'}/>
                                </React.Suspense>
                            } 
                            />
                            <Route path="/workcare" element={
                                <React.Suspense fallback={<SliderPages/>}>
                                    <LazyWorkCareDash context={'workcare'} request="WorkCareRequest" header={'Work Care Requests'}/>
                                </React.Suspense>
                            } 
                            />
                            <Route path="/nursingDash" element={
                                <React.Suspense fallback={<SliderPages/>}>
                                    {/* <LazyNursingCareDash/> */}
                                    <LazyWorkCareDash request="NursingRequests" context={'nursing'} header={'Nursing Care Requests'}/>
                                </React.Suspense>
                            } 
                            />
                            <Route path="/DrDashBoard" element={
                                <React.Suspense fallback={<SliderPages/>}>
                                    {/* <LazyTelehealthCareDash/> */}
                                    <LazyDrDashBoard request="GetDrRequests" context={'Dr DashBoard'} header={'Your Requested Petients'}/>
                                </React.Suspense>
                            } 
                            />
                            <Route path="/telehealthDash" element={
                                <React.Suspense fallback={<SliderPages/>}>
                                    {/* <LazyTelehealthCareDash/> */}
                                    <LazyWorkCareDash request="telehealthCareRequests" context={'telehealth'} header={'Telehealth Requests'}/>
                                </React.Suspense>
                            } 
                            />
                            <Route path="/SchoolDash" element={
                                <React.Suspense fallback={<SliderPages/>}>
                                    {/* <LazySchoolCareDash/> */}
                                    <LazyWorkCareDash request="schoolName" context={'school'} header={"School Care Dash"}/>
                                </React.Suspense>
                            } 
                            />
                            <Route path="/ctopHubDash" element={
                                <React.Suspense fallback={<SliderPages/>}>
                                    {/* <LazyCtophubDash/> */}
                                    <LazyWorkCareDash request="CTOPHubRequest" context={'ctopHub'} header={"CTOP hub Requests"}/>
                                </React.Suspense>
                            } 
                            />
                            <Route path="/diagnosticDash" element={
                                <React.Suspense fallback={<SliderPages/>}>
                                    {/* <LazyDiagnosisAndImaging/> */}
                                    <LazyWorkCareDash request="DiagnosisRequest" context={'diagnostic'} header={"Diagnostic & Imaging Requests"}/>
                                </React.Suspense>
                            } 
                            />
                            <Route path="/pathalogyDash" element={
                                <React.Suspense fallback={<SliderPages/>}>
                                    {/* <LazyPathalogyDash/> */}
                                    <LazyWorkCareDash request="PathalogyRequests" context={'pathalogy'} header={"Pathalogy Requests"}/>
                                </React.Suspense>
                            } 
                            />
                            <Route path="/pharmacyDash" element={
                                <React.Suspense fallback={<SliderPages/>}>
                                    {/* <LazyPharmacyDash/> */}
                                    <LazyWorkCareDash request="PharmacyRequest" context={'pharmacy'} header={"Pharmacy Requests"}/>
                                </React.Suspense>
                            } 
                            />
                            <Route path="/petientTransportDash" element={
                                <React.Suspense fallback={<SliderPages/>}>
                                    {/* <LazyPetientDash/> */}
                                    <LazyWorkCareDash request="petientTransportrRequest" context={'patientTransport'} header={"Petient Transport Requests"}/>
                                </React.Suspense>
                            } 
                            />
                            <Route path="/otherRequestDash" element={
                                <React.Suspense fallback={<SliderPages/>}>
                                    <LazyWorkCareDash request="otherRequests" context={'otherForms'} header={'Other Requests'}/>
                                </React.Suspense>
                            } 
                            />
                            <Route path="/drRequestHandling" element={
                                <React.Suspense fallback={<SliderPages/>}>
                                    <LazyDrAutherizationGiving context={'Doctor Autherization Section'} route={'drProfile'} user={'dr'} header={'Doctor Autherization Section'}/>
                                </React.Suspense>
                            } 
                            />
                            <Route path="/minorAdminAdding" element={
                                <React.Suspense fallback={<SliderPages/>}>
                                    <LazyAuthrizationGiving context={'Admin Autherization Section'} route={'userInfo'} user={'admin'} header={'Admin Autherization Section'}/>
                                </React.Suspense>
                            } 
                            />
                            <Route path="/drRequests" element={
                                <React.Suspense fallback={<SliderPages/>}>
                                    <LazyDrRequest context={'Practitionar Requests'} route={'userInfo'} user={'admin'} header={'Practitionar Request Section'}/>
                                </React.Suspense>
                            } 
                            />
                        </Routes>
                    </DashBoard>
                </AdminAuthoritiesProvider>
            </Router>
    )
}